export default {
  'imm5406.familyMemberTableTitle': '家庭成员',
  'imm5406.familyMemberTableFullName': '姓名',
  'imm5406.familyMemberTableStatus': '状态',
  'imm5406.familyMemberTableStatus.missingInformation': '缺少信息',
  'imm5406.familyMemberTableStatus.complete': '完成',

  'imm5406.title.applicant': '申请人',
  'imm5406.title.partner': '配偶、同居伴侣或事实婚姻伴侣（如果适用）',
  'imm5406.title.mother': '母亲',
  'imm5406.title.father': '父亲',
  'imm5406.title.child': '子女',
  'imm5406.title.siblings': '兄弟姐妹',
  'imm5406.title.formList.child': '子女 #',
  'imm5406.title.formList.siblings': '兄弟姐妹 #',

  'imm5406.description.sibling': '包括同父异母、同母异父和继兄妹。',
  'imm5406.description.maritalStatus.marriedPhysicallyPresent':
    '如果您已婚且您的配偶亲自出席了婚礼，请在“婚姻状况”下选择“已婚 - 亲自出席”',
  'imm5406.description.maritalStatus.marriedNotPhysicallyPresent':
    '如果您已婚但您的配偶没有亲自出席婚礼，请在“婚姻状况”下选择“已婚 - 未亲自出席”',

  'imm5406.fullName': '姓名',
  'imm5406.dateOfBirth': '出生日期（年/月/日）',
  'imm5406.countryOfBirth': '出生国家或地区',
  'imm5406.applicantMaritalStatus':
    '婚姻状况（例如已婚 - 亲自出席、已婚 - 未亲自出席、同居伴侣、单身、离婚、丧偶、分居）',
  'imm5406.partnerMaritalStatus':
    '婚姻状况（例如已婚 - 亲自出席、已婚 - 未亲自出席、同居伴侣、离婚、丧偶、分居、不适用 - 已故）',
  'imm5406.otherDependantMaritalStatus':
    '婚姻状况（例如已婚、同居伴侣、单身、离婚、丧偶、分居、不适用 - 已故）',
  'imm5406.emailAddress': '电子邮件地址',
  'imm5406.address': '提供地址。给出城市/城镇和国家或地区（最多80个字符）：',
  'imm5406.deceasedAddress':
    '提供地址。如果已故，请提供城市/城镇、国家或地区和日期（最多80个字符）：',
  'imm5406.relationship': '关系',

  'imm5406.steps.sectionA': 'A部分',
  'imm5406.steps.sectionB': 'B部分 - 子女',
  'imm5406.steps.sectionC': 'C部分 - 兄弟姐妹',
};
